import React from "react";
import { Routes, Route } from "react-router-dom";
import ReclamosPage from "../pages/ReclamosPage";
import ReclamoDetalle from "../pages/ReclamoDetalle";

const ReclamosRoutes = () => (
  <Routes>
    <Route path="" element={<ReclamosPage />} />
    <Route path=":id" element={<ReclamoDetalle />} />
  </Routes>
);

export default ReclamosRoutes;
